export default {
    key: "market",
    basePath: "/health-care-market",
    exclude: false,
  };
  